import React from "react";
import SmoothCollapse from "./SmoothCollapse";

const normalizeCampaignType = (...values) => {
  for (const value of values) {
    const v = String(value || "").toLowerCase();
    if (v === "auto") return "auto";
    if (v === "manual") return "manual";
  }
  return "unknown";
};

const ScheduleTable = ({ schedules, campaigns = [], onEdit, onDelete, onToggleEnabled }) => {
  if (!Array.isArray(campaigns)) {
    console.warn("⚠ ScheduleTable: campaigns が配列ではありません", campaigns);
    return <p>キャンペーンデータを取得中です...</p>;
  }

  if (!Array.isArray(schedules)) {
    console.warn("⚠ ScheduleTable: schedules が配列ではありません", schedules);
    return <p>スケジュール情報を取得中です...</p>;
  }

  console.log("campaigns sample:", campaigns.slice(0, 5));
  console.log("schedules sample:", schedules.slice(0, 5));

  const grouped = schedules.reduce((acc, s) => {
    if (!acc[s.campaignId]) acc[s.campaignId] = [];
    acc[s.campaignId].push(s);
    return acc;
  }, {});

  const cellStyle = {
    border: "1px solid #ddd",
    padding: "6px 10px",
    textAlign: "center",
    fontSize: "1rem",
  };

  const leftCellStyle = {
    ...cellStyle,
    textAlign: "left",
  };

  const buttonStyle = {
    minHeight: "32px",
    padding: "4px 8px",
    fontSize: "0.85rem",
    cursor: "pointer",
    margin: "2px",
  };

  return (
    <div
      style={{
        padding: "16px",
        boxSizing: "border-box",
        backgroundColor: "#f5f9fc",
        borderRadius: "6px",
      }}
    >
      {Object.entries(grouped)
        .sort(([aId], [bId]) => {
          const aName = campaigns.find(c => String(c.id) === String(aId))?.name || "";
          const bName = campaigns.find(c => String(c.id) === String(bId))?.name || "";
          return aName.localeCompare(bName);
        })
        .map(([campaignId, items]) => {
          const matchedCampaign = campaigns.find(
            c => String(c.id) === String(campaignId)
          );
          const rawMode = (matchedCampaign?.mode || "unknown").toLowerCase();
          const campaignName =
            matchedCampaign?.name ||
            items?.[0]?.campaignName ||
            `campaignId:${campaignId}`;
          const campaignType = normalizeCampaignType(
            matchedCampaign?.mode,
            matchedCampaign?.targetingType,
            items?.[0]?.targetingType,
            items?.[0]?.mode
          );
          const isAuto = campaignType === "auto";
          const isManual = campaignType === "manual";

        console.log(`🧪 campaignId: ${campaignId}, rawMode: ${rawMode}`, {
          matchedCampaign: matchedCampaign
            ? {
                id: matchedCampaign.id,
                idType: typeof matchedCampaign.id,
                mode: matchedCampaign.mode,
                targetingType: matchedCampaign.targetingType,
              }
            : null,
          scheduleCampaignId: items?.[0]?.campaignId,
          scheduleCampaignIdType: typeof items?.[0]?.campaignId,
          scheduleTargetingType: items?.[0]?.targetingType,
          scheduleMode: items?.[0]?.mode,
          campaignType,
          isAuto,
          isManual,
        });

        const modeIcon = (
          <>
            {isAuto && (
              <img src="/a_icon.png" alt="オート" style={{ width: 18, verticalAlign: "middle" }} />
            )}
            {isManual && (
              <img src="/m_icon.png" alt="マニュアル" style={{ width: 18, verticalAlign: "middle" }} />
            )}
          </>
        );

        return (
          <SmoothCollapse
            key={campaignId}
            summary={
              <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                {modeIcon}
                {campaignName}
              </span>
            }
          >
            <div style={{ overflowX: "auto" }}>
              <table
                className="schedule-table"
                style={{
                  width: "100%",
                  minWidth: "720px",
                  borderCollapse: "collapse",
                  border: "1px solid #ddd",
                  backgroundColor: "white",
                  marginBottom: "16px",
                }}
              >
                <thead style={{ backgroundColor: "#f5f5f5" }}>
                  <tr>
                    <th style={leftCellStyle}>配信状態</th>
                    <th style={cellStyle}>モード</th>
                    <th style={cellStyle}>時</th>
                    <th style={cellStyle}>分</th>
                    <th style={cellStyle}>曜日 / 日時</th>
                    <th style={cellStyle}>予算</th>
                    <th style={cellStyle}>有効</th>
                    <th style={cellStyle}>操作</th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((s) => (
                    <tr key={s._id}>
                      <td style={cellStyle}>{s.state === "ENABLED" ? "ON" : "OFF"}</td>
                      <td style={cellStyle}>
                        {s.mode === "once" ? "1回" : s.mode === "daily" ? "毎日" : "-"}
                      </td>
                      <td style={cellStyle}>
                        {s.hour != null ? String(s.hour).padStart(2, "0") : "-"}
                      </td>
                      <td style={cellStyle}>
                        {s.minute != null ? String(s.minute).padStart(2, "0") : "-"}
                      </td>
                      <td style={cellStyle}>
                        {s.weekdays?.length
                          ? s.weekdays
                              .slice()
                              .sort((a, b) => a - b)
                              .map((d) => "日月火水木金土"[d])
                              .join(",")
                          : s.scheduledDateTime
                          ? new Date(s.scheduledDateTime).toLocaleString()
                          : "-"}
                      </td>
                      <td style={cellStyle}>
                        {s.budget != null ? `${s.budget.toLocaleString()}円` : "-"}
                      </td>
                      <td style={cellStyle}>{s.enabled ? "✅" : "❌"}</td>
                      <td style={cellStyle}>
                        <button style={buttonStyle} onClick={() => onEdit(s)}>編集</button>{" "}
                        <button style={buttonStyle} onClick={() => onDelete(s._id)}>削除</button>{" "}
                        <button style={buttonStyle} onClick={() => onToggleEnabled(s)}>
                          {s.enabled ? "無効化" : "有効化"}
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </SmoothCollapse>
        );
      })}
    </div>
  );
};

export default ScheduleTable;